import { HighlightedFeedbackText } from '@modules/feedback/components/FeedbackHighlighter/HighlightedFeedbackText';
import { Highlight } from '@modules/feedback/types';
import { Box, Typography } from '@mui/material';
import { FeedbackResponse } from 'v2/core/entities/feedback/content';

interface SurveyTypeAnswerProps {
  answer: FeedbackResponse['answer'];
  highlights: Highlight[];
  msgIndex: number;
  showOriginalLanguage: boolean;
}

const SurveyTypeAnswer = ({
  answer,
  highlights,
  msgIndex,
  showOriginalLanguage,
}: SurveyTypeAnswerProps) => {
  if (!answer) {
    return null;
  }

  return (
    <Typography
      variant="body1"
      sx={{
        wordBreak: 'break-word',
        whiteSpace: 'pre-line',
      }}
    >
      <Box marginLeft={4}>
        <HighlightedFeedbackText
          text={answer}
          highlights={highlights}
          showOriginalLanguage={showOriginalLanguage}
          msgIndex={msgIndex}
        />
      </Box>
    </Typography>
  );
};

export default SurveyTypeAnswer;
